// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1t0g2","selected":"Chip_selected__3AmWK"};